import React, { Component } from "react";
import QRCode from 'react-qr-code';
import {isMobile} from 'react-device-detect';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import './media.css';
// import {addMedia} from '../../../actions/ui/marketplace';

export default class SmallCard extends Component {
  render(){
    // window.localStorage.setItem(`${this.state.ticker}.${this.props.address}`,1000);
    let balance = window.localStorage.getItem(`${this.props.ticker}.${this.props.address}`);

    return (
      <>
      <div className="card" style={{border:'1px solid grey',width:'100%',borderRadius:'7%'}}>
        <div className="card-image" style={{height:'120px'}}>
          <div className='center' style={{position:'absolute',top:'10px',marginLeft:'calc(50% - 50px)',height:'100px',width:'100px',border:'4px solid black',background:'white',borderRadius:'50%',padding:'10px'}}>
             <img className='circle' src={this.props.ticker ? 'kg.jpg' : "./person.png"} style={{borderRadius:'50%',border:'2px solid black'}} />
          </div>
        </div>
        <div className="card-content mediaSupply2" style={{paddingTop:'10px',paddingLeft:'15px',paddingRight:'15px',paddingBottom:'0px'}}>
          <span className="card-title" style={{color:'black'}}>{this.props.name}</span>
          <div className='row'>
             <p style={{float:'left',margin:'5px 0px',color:'grey'}}> Total Supply</p>
             <p style={{float:'right',margin:'5px 0px'}}>{this.props.total} {this.props.ticker}</p>
          </div>
          <div className='row'>
             <p style={{float:'left',margin:'5px 0px',color:'grey'}}> Circulating Supply</p>
             <p style={{float:'right',margin:'5px 0px'}}>{this.props.circulating} {this.props.ticker}</p>
          </div>
          <div className='row' style={{paddingBottom:'5px'}}>
             <p style={{float:'left',margin:'5px 0px',color:'grey'}}> Balance</p>
             <p style={{float:'right',margin:'5px 0px'}}>{this.props.balance ? this.props.balance : balance} {this.props.ticker}</p>
          </div>
        </div>
      </div>
      </>
    )
  }
}
